import './HDayTripBooking.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { BOOKING_ACTION_BUTTON_SETTINGS_MAP, Hyperlink } from '~/schemes';
import { HBtn } from '~/components';
import { GFEventCategory } from '~/plugins/gfev';
import { mergeVNodeData } from '~/helpers';
import { DayTripBookingActionButtonColor } from '~/server-middleware/data-server/adapter/ACCOAdapter/@types';

export interface HDayTripBookingProps {
  bookingSiteLink?: Hyperlink;
  color?: string;
  eventId?: string;
}

export interface HDayTripBookingEmits {}

export interface HDayTripBookingScopedSlots {}

export const HDayTripBooking = tsx.component({
  name: 'HDayTripBooking',
  functional: true,

  props: {
    bookingSiteLink: Object as PropType<Hyperlink | undefined>,
    color: Object as PropType<DayTripBookingActionButtonColor | undefined>,
    eventId: String,
  },

  render(h, { data, props, parent }): VNode {
    const { bookingSiteLink, color = 'default', eventId } = props;

    // bookingSiteLinkが存在しない場合は何も表示しない
    if (!bookingSiteLink || !bookingSiteLink.url) {
      return h('span', { style: { display: 'none' } }) as VNode;
    }

    const colorSettings =
      BOOKING_ACTION_BUTTON_SETTINGS_MAP[color || 'default'];

    const customStyle = {
      backgroundColor: colorSettings.bgColor,
      color: colorSettings.color,
      borderColor: colorSettings.bgColor,
    };

    const directives = eventId
      ? [
          {
            name: 'ev',
            value: {
              category: GFEventCategory.Link,
              action: bookingSiteLink.url,
              eventId,
            },
          },
        ]
      : undefined;

    return (
      <div
        {...mergeVNodeData(data, {
          staticClass: 'h-hotel-to-booking',
          directives: [
            {
              name: 'show',
              value: true,
            },
          ],
        })}>
        <HBtn
          {...(mergeVNodeData(data, {
            staticClass: 'h-day-trip-booking',
            attrs: {
              href: bookingSiteLink.url,
              target: '_blank',
            },
            style: customStyle,
            directives,
          }) as any)}>
          {bookingSiteLink.text || parent.$t('action.reserve')}
        </HBtn>
      </div>
    );
  },
});
